import React, { useState } from 'react';
import { RxCross2 } from 'react-icons/rx';
import { FiSearch } from 'react-icons/fi';

const FeeDetailsModal = ({ isOpen, onClose, feeDetail }) => {
  console.log(feeDetail, 'feeDetail');
  if (!isOpen) return null;

  const filterInstallments = (installments, isSwap) => {
    if (!installments) return [];
    return installments.filter(
      (installment) => installment.isSwapPayment === isSwap
    );
  };

  const renderInstallmentDetails = (installments, title) => (
    <>
      <h4 className="font-medium text-navy-700 dark:text-white">{title}:</h4>
      <div className="grid grid-cols-1 gap-2 md:grid-cols-2 lg:grid-cols-3">
        {installments.map((installment, idx) => (
          <div
            key={idx}
            className="rounded-lg border border-gray-200 bg-white p-3 dark:border-navy-600 dark:bg-navy-800"
          >
            <div className="flex items-center justify-between">
              <span className="font-medium">
                Amount: ₹{installment.amount.toLocaleString()}
              </span>

              {installment.isPaid ? (
                <span className="rounded-full bg-green-100 px-2 py-1 text-xs font-medium text-green-800">
                  Paid
                </span>
              ) : (
                <span className="rounded-full bg-red-100 px-2 py-1 text-xs font-medium text-red-800">
                  Pending
                </span>
              )}
            </div>

            <div className="mt-2 text-sm text-navy-800 dark:text-gray-300">
              Due Date: {new Date(installment.dueDate).toLocaleDateString()}
            </div>
            {installment.isEmiInstallment && (
              <div className="mt-1 text-xs text-navy-600 dark:text-gray-400">
                EMI Payment
              </div>
            )}
            {installment.afterLoanDeduction > 0 && (
              <div className="mb-2 flex items-center justify-between text-sm font-semibold">
                <span className="text-sm font-medium text-navy-700 dark:text-gray-400">
                  Amount After Deduction
                </span>
                <span>₹{installment.afterLoanDeduction.toLocaleString()}</span>
              </div>
            )}
          </div>
        ))}
      </div>
    </>
  );

  const renderPaymentHistory = (swapPayments) => (
    <div className="mt-4">
      <h4 className="mb-2 font-medium text-navy-700 dark:text-white">
        Swap Payment History:
      </h4>
      <div className="grid grid-cols-1 gap-2 md:grid-cols-2 lg:grid-cols-3">
        {swapPayments.map((payment, idx) => (
          <div
            key={idx}
            className="rounded-lg border border-gray-200 bg-white p-3 dark:border-navy-600 dark:bg-navy-800"
          >
            <div className="grid grid-cols-2 gap-1 text-sm text-navy-800 dark:text-gray-400">
              <span className="font-medium text-navy-800 dark:text-gray-400">
                Date:
              </span>
              <span>{new Date(payment.swapDate).toLocaleDateString()}</span>
              <span className="font-medium text-navy-800 dark:text-gray-400">
                Amount:
              </span>
              <span>₹{payment.totalSwapAmount.toLocaleString()}</span>
              <span className="font-medium text-navy-800 dark:text-gray-400">
                Status:
              </span>
              <span>
                {payment.isFullPayment ? (
                  <span className="rounded-full bg-green-100 px-2 py-1 text-xs font-medium text-green-800">
                    Completed
                  </span>
                ) : (
                  <span className="rounded-full bg-yellow-100 px-2 py-1 text-xs font-medium text-yellow-800">
                    In Progress
                  </span>
                )}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  const hasSwaps = feeDetail.swapPayments?.length > 0;

  return (
    <div className="bg-black/50 fixed inset-0 z-50 flex items-center justify-center">
      <div className="relative max-h-[90vh] w-full max-w-4xl overflow-y-auto rounded-lg border border-gray-200 bg-white p-6 shadow-xl dark:border-gray-800 dark:bg-navy-700">
        <button
          onClick={onClose}
          className="absolute right-4 top-4 text-navy-700 hover:text-red-500 dark:text-white"
        >
          <RxCross2 size={24} />
        </button>
        <h3 className="mb-4 text-xl font-bold text-navy-700 dark:text-white">
          Fee Details for {feeDetail.name}
        </h3>

        <div className="space-y-6">
          <div className="grid grid-cols-2 gap-4 text-sm text-navy-800 dark:text-gray-300">
            <div>
              <span className="font-medium">Total Amount:</span> ₹
              {feeDetail.totalAmount.toLocaleString()}
            </div>
            <div>
              <span className="font-medium">Paid Amount:</span> ₹
              {feeDetail.paidAmount.toLocaleString()}
            </div>
            <div>
              <span className="font-medium">Remaining Amount:</span> ₹
              {feeDetail.remainingAmount.toLocaleString()}
            </div>
            <div>
              <span className="font-medium">Payment Status:</span>{' '}
              {feeDetail.remainingAmount === 0 ? (
                <span className="rounded-full bg-green-100 px-2 py-1 text-xs font-medium text-green-800">
                  Paid
                </span>
              ) : (
                <span className="rounded-full bg-red-100 px-2 py-1 text-xs font-medium text-red-800">
                  Pending
                </span>
              )}
            </div>
            <div>
              <span className="font-medium">Payment Type:</span>{' '}
              {feeDetail.isFullPayment ? (
                <span className="rounded-full px-2 py-1 text-sm font-medium text-navy-800 dark:text-white">
                  Full Payment
                </span>
              ) : (
                <span className="rounded-full px-2 py-1 text-sm font-medium text-navy-800 dark:text-white">
                  Partial Payment
                </span>
              )}
            </div>
            {hasSwaps && (
              <div>
                <span className="font-medium">Has Course Swaps:</span>{' '}
                <span className="rounded-full bg-purple-100 px-2 py-1 text-xs font-medium text-purple-800">
                  Yes
                </span>
              </div>
            )}
          </div>

          {feeDetail.installments?.length > 0 && (
            <div className="space-y-6">
              {renderInstallmentDetails(
                filterInstallments(feeDetail.installments, false),
                'Regular Installment Details'
              )}
            </div>
          )}

          {hasSwaps && (
            <>
              {feeDetail.swapPayments.some(
                (sp) => sp.swapInstallments?.length > 0
              ) && (
                <div className="space-y-6">
                  {renderInstallmentDetails(
                    feeDetail.swapPayments.flatMap(
                      (sp) => sp.swapInstallments || []
                    ),
                    'Swap Installment Details'
                  )}
                </div>
              )}
              {/* {renderPaymentHistory(feeDetail.swapPayments)} */}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

const StudentFeeDetails = ({ students, loadingStudent }) => {
  const [selectedFeeDetail, setSelectedFeeDetail] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');

  if (loadingStudent) {
    return (
      <div className="w-full rounded-lg bg-white pt-6 dark:bg-navy-800">
        <h2 className="mb-6 text-xl font-bold text-navy-700 dark:text-white">
          Loading student details...
        </h2>
      </div>
    );
  }

  if (!students || students.length === 0) {
    return (
      <div className="w-full rounded-lg bg-white pt-6 dark:bg-navy-800">
        <h2 className="mb-6 text-xl font-bold text-navy-700 dark:text-white">
          No student fee details available
        </h2>
      </div>
    );
  }

  // Filter students based on search query
  const filteredStudents = students.filter((studentData) => {
    const query = searchQuery.toLowerCase();
    return (
      studentData.student.name.toLowerCase().includes(query) ||
      studentData.student.contactNumber.toLowerCase().includes(query)
    );
  });

  return (
    <>
      <div className="w-full rounded-lg bg-white p-6 dark:bg-navy-800">
        <div className="flex flex-col gap-5">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between">
            <h2 className="text-xl font-bold text-navy-700 dark:text-white">
              Student Fee Details
            </h2>

            <div className="relative mt-4 md:mt-0">
              <div className="relative flex items-center">
                <span className="absolute left-3 text-gray-400">
                  <FiSearch size={16} />
                </span>
                <input
                  type="text"
                  placeholder="Search by name or contact..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="w-full rounded-lg border border-gray-300 py-2 pl-10 pr-4 focus:border-blue-500 focus:outline-none dark:border-navy-600 dark:bg-navy-700 dark:text-white md:w-64"
                />
                {searchQuery && (
                  <button
                    onClick={() => setSearchQuery('')}
                    className="absolute right-3 text-gray-400 hover:text-gray-600"
                  >
                    <RxCross2 size={16} />
                  </button>
                )}
              </div>
            </div>
          </div>

          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-gray-200 dark:border-navy-700">
                  <th className="px-6 py-3 text-left text-sm font-medium text-navy-700 dark:text-white">
                    Student Name
                  </th>
                  <th className="px-6 py-3 text-left text-sm font-medium text-navy-700 dark:text-white">
                    Contact
                  </th>
                  <th className="px-6 py-3 text-left text-sm font-medium text-navy-700 dark:text-white">
                    Batch Fees
                  </th>
                  <th className="px-6 py-3 text-left text-sm font-medium text-navy-700 dark:text-white">
                    Enrollment Fees
                  </th>
                  <th className="px-6 py-3 text-left text-sm font-medium text-navy-700 dark:text-white">
                    Paid Fees
                  </th>
                  <th className="px-6 py-3 text-left text-sm font-medium text-navy-700 dark:text-white">
                    Remaining Fees
                  </th>
                  <th className="px-6 py-3 text-left text-sm font-medium text-navy-700 dark:text-white">
                    Payment Type
                  </th>
                  <th className="px-6 py-3 text-left text-sm font-medium text-navy-700 dark:text-white">
                    Status
                  </th>
                  <th className="px-6 py-3 text-left text-sm font-medium text-navy-700 dark:text-white">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredStudents.length > 0 ? (
                  filteredStudents.map((studentData, studentIndex) => (
                    <tr
                      key={studentIndex}
                      className="border border-b border-gray-200 hover:bg-gray-50 dark:border-navy-700 dark:hover:bg-navy-700/50"
                    >
                      <td className="px-6 py-4 text-sm font-medium text-navy-700 dark:text-white">
                        {studentData.student.name}
                      </td>
                      <td className="px-6 py-4 text-sm text-navy-800 dark:text-gray-300">
                        {studentData.student.contactNumber}
                      </td>
                      <td className="px-6 py-4 text-sm text-navy-800 dark:text-gray-300">
                        ₹{studentData.feeDetails.batchFee.toLocaleString()}
                      </td>
                      <td className="px-6 py-4 text-sm text-navy-800 dark:text-gray-300">
                        ₹{studentData.feeDetails.totalAmount.toLocaleString()}
                      </td>
                      <td className="px-6 py-4 text-sm text-navy-800 dark:text-gray-300">
                        ₹{studentData.feeDetails.paidAmount.toLocaleString()}
                      </td>
                      <td className="px-6 py-4 text-sm text-navy-800 dark:text-gray-300">
                        ₹
                        {studentData.feeDetails.remainingAmount.toLocaleString()}
                      </td>
                      <td className="px-6 py-4">
                        {studentData.feeDetails.isFullPayment ? (
                          <span className="rounded-full px-2 py-1 text-sm font-medium text-navy-800 dark:text-white">
                            Full Payment
                          </span>
                        ) : (
                          <span className="rounded-full px-2 py-1 text-sm font-medium text-navy-800 dark:text-white">
                            Partial Payment
                          </span>
                        )}
                      </td>
                      <td className="px-6 py-4">
                        {studentData.feeDetails.remainingAmount === 0 ? (
                          <span className="rounded-full bg-green-100 px-2 py-1 text-xs font-medium text-green-800">
                            Paid
                          </span>
                        ) : (
                          <span className="rounded-full bg-red-100 px-2 py-1 text-xs font-medium text-red-800">
                            Pending
                          </span>
                        )}
                      </td>
                      <td className="px-6 py-4">
                        <button
                          onClick={() =>
                            setSelectedFeeDetail({
                              name: studentData.student.name,
                              ...studentData.feeDetails,
                            })
                          }
                          className="rounded-full bg-blue-100 px-2 py-1 text-xs font-medium text-blue-800 hover:bg-blue-200"
                        >
                          View Details
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="9"
                      className="px-6 py-4 text-center text-sm text-gray-500 dark:text-gray-400"
                    >
                      No students match your search criteria
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {selectedFeeDetail && (
        <FeeDetailsModal
          isOpen={!!selectedFeeDetail}
          onClose={() => setSelectedFeeDetail(null)}
          feeDetail={selectedFeeDetail}
        />
      )}
    </>
  );
};

export default StudentFeeDetails;
